import { render, staticRenderFns } from "./BaseLevelFilterContainer.vue?vue&type=template&id=1d645594"
import script from "./BaseLevelFilterContainer.vue?vue&type=script&lang=js"
export * from "./BaseLevelFilterContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports